import router from './router'
import useProductStore from './store'
import ProductMessages from './localization'

export default {
  router,
  useProductStore,
  localization: ProductMessages,
}
